import ScopesGraph from "./ScopesGraph/ScopesGraph";
import FindingsByTicketStatus from "./FindingsByTicketStatus/FindingsByTicketStatus";
import AverageAgeBySeverity from "./AverageAgeBySeverity/AverageAgeBySeverity";
import NewFindingsByCategory from "./Deprecated/NewFindingsByCategory/NewFindingsByCategory";
import AvgAgeByCategory from "./Deprecated/AvgAgeByCategory/AvgAgeByCategory";
import FindingsByStatusAndCategory from "./Deprecated/FindingsByStatusAndCategory/FindingsByStatusAndCategory";
import TicketDueDate from "./SLA/TicketDueDate/TicketDueDate";
import Compliance from "./SLA/Compliance/Compliance";
import FixedFindings from "./SLA/FixedFindings/FixedFindings";
import Performances from "./SLA/Performances/Performances";
import OverdueFindingsBySeverity from "./SLA/OverdueFindingsBySeverity/OverdueFindingsBySeverity";
import RiskPosture from "./Trends/RiskPosture/RiskPosture";
import FindingsByDataSource from "./Deprecated/FindingsByDataSource/FindingsByDataSource";
import NewVSClosed from "./Trends/NewVSClosed/NewVSClosed";
import AvgAgeBySeverity from "./Trends/AvgAgeBySeverity/AvgAgeBySeverity";
import AllFindingsKPI from "./DashboardKPIs/FindingsKPICard/AllFindingsKPI";
import CriticalFindingsKPI from "./DashboardKPIs/FindingsKPICard/CriticalFindingsKPI";
import HighFindingsKPI from "./DashboardKPIs/FindingsKPICard/HighFindingsKPI";
import AllFindingResourcesKPI from "./DashboardKPIs/FindingReosourcesKPICard/AllFindingResourcesKPI";
import NewFindingsByDiscoveryDate from "./Trends/OneSeriesByDiscoveryDate/NewFindingsByDiscoveryDate";
import OpenFindingsByDiscoveryDate from "./Trends/OneSeriesByDiscoveryDate/OpenFindingsByDiscoveryDate";
import ExpectedWorkload from "./SLA/ExpectedWorkload/ExpectedWorkload";
import FindingsByDataSourceAndSeverityTable from "./TableCharts/FindingsByDataSourceAndSeverity/FindingsByDataSourceAndSeverityTable";
import AvgFixTimeBySLARulesTable from "./TableCharts/AvgFixTimeBySLARules/AvgFixTimeBySLARulesTable";
import FindingsBySeverity from "./FindingsBySeverity/FindingsBySeverity";
import SLABySeverityTable from "./TableCharts/SLABySeverity/SLABySeverityTable";
import DueDateBySeverityTable from "./TableCharts/DueDateBySeverity/DueDateBySeverityTable";
import CriticalFindingResourcesKPI from "./DashboardKPIs/FindingReosourcesKPICard/CriticalFindingsResourcesCountKPI";
import HighFindingResourcesCountKPI from "./DashboardKPIs/FindingReosourcesKPICard/HighFindingResourcesCountKPI";
import AvgTicketAge from "./Trends/AvgTicketAge/AvgTicketAge";
import AvgTicketAgeBySeverity from "./Trends/AvgTicketAgeBySeverity/AvgTicketAgeBySeverity";
import TicketsByStatus from "./Trends/TicketsByStatus/TicketsByStatus";
import FindingsSummaryKPI from "./DashboardKPIs/SeemplicityKPIs/FindingsSummaryKPI/FindingsSummaryKPI";
import FindingsByCategory from "./FindingsByCategory/FindingsByCategory";
import FindingsByAppsecSubCategory from "./FindingsByAppsecSubCategory/FindingsByAppsecSubCategory";
import TopCommonIssues from "./TableCharts/TopCommonIssues/TopCommonIssues";
import TopRepositoriesTable from "./TableCharts/TopFeatureTables/TopRepositories/TopRepositoriesTable";
import TopCloudAccountsTable from "./TableCharts/TopFeatureTables/TopCloudAccounts/TopCloudAccountsTable";
import TopPackagesTable from "./TableCharts/TopFeatureTables/TopPackages/TopPackagesTable";
import TopFixesTable from "./TableCharts/TopFeatureTables/TopFixes/TopFixesTable";
import InventoryFindingsByDatasources from "./DashboardKPIs/InventoryKPIs/InventoryFindingsByDatasources";
import InventoryCloudAccountsKPI from "./DashboardKPIs/InventoryKPIs/InventoryCloudAccountsKPI";
import InventoryRepositoriesKPI from "./DashboardKPIs/InventoryKPIs/InventoryRepositoriesKPI";
import QueuesSummaryKPI from "./DashboardKPIs/SeemplicityKPIs/QueuesSummaryKPI/QueuesSummaryKPI";

export const WIDGET_KEY_TO_COMPONENT = {
  scopes_graph: ScopesGraph,
  findings_by_data_source_and_severity: FindingsByDataSourceAndSeverityTable,
  findings_by_ticket_status: FindingsByTicketStatus,
  avg_age_by_severity_bars: AverageAgeBySeverity,
  new_findings_by_category: NewFindingsByCategory,
  avg_age_by_category: AvgAgeByCategory,
  findings_by_status_and_category: FindingsByStatusAndCategory,
  ticket_due_date: TicketDueDate,
  sla_compliance: Compliance,
  sla_fixed_findings: FixedFindings,
  performances_kpi: Performances,
  overdue_findings_by_severity: OverdueFindingsBySeverity,
  risk_posture: RiskPosture,
  findings_by_data_source: FindingsByDataSource,
  findings_by_new_vs_closed: NewVSClosed,
  avg_age_by_severity_trend: AvgAgeBySeverity,
  new_findings_by_discovery_date: NewFindingsByDiscoveryDate,
  open_findings_by_discovery_date: OpenFindingsByDiscoveryDate,
  all_findings_kpi: AllFindingsKPI,
  critical_findings_kpi: CriticalFindingsKPI,
  high_findings_kpi: HighFindingsKPI,
  expected_workload: ExpectedWorkload,
  avg_fix_time_by_sla_rules: AvgFixTimeBySLARulesTable,
  resources_count_kpi: AllFindingResourcesKPI,
  critical_findings_resources_count_kpi: CriticalFindingResourcesKPI,
  high_findings_resources_count_kpi: HighFindingResourcesCountKPI,
  findings_by_severity: FindingsBySeverity,
  sla_by_severity_table: SLABySeverityTable,
  due_date_by_severity_table: DueDateBySeverityTable,
  avg_ticket_age_trend: AvgTicketAge,
  avg_ticket_age_by_severity_trend: AvgTicketAgeBySeverity,
  tickets_by_status_trend: TicketsByStatus,
  findings_summary_kpi: FindingsSummaryKPI,
  findings_by_category: FindingsByCategory,
  findings_by_appsec_sub_category: FindingsByAppsecSubCategory,
  top_common_issues: TopCommonIssues,
  top_10_vulnerable_repositories: TopRepositoriesTable,
  top_10_vulnerable_cloud_accounts: TopCloudAccountsTable,
  top_10_vulnerable_packages: TopPackagesTable,
  top_10_fixes: TopFixesTable,
  inventory_cloud_accounts_by_provider: InventoryCloudAccountsKPI,
  inventory_code_repository_by_platform: InventoryRepositoriesKPI,
  inventory_findings_by_datasource: InventoryFindingsByDatasources,
  queues_count_by_endpoint_type: QueuesSummaryKPI,
};

export const WIDGET_TYPE_TO_ICON = {
  AllFindingsKPI: "counter",
  CriticalFindingsKPI: "counter",
  HighFindingsKPI: "counter",
  ResourcesCountKPI: "counter",
  BarChart: "bar",
  ColumnChart: "bar",
  FixedFindingsKPI: "counter",
  MultiColumnChart: "stacked-bar",
  PieChart: "pie",
  ScopesOverview: "table",
  StackedBarChart: "stacked-bar",
  StackedColumnChart: "stacked-bar",
  TrendChart: "trend",
  CriticalFindingResourcesCountKPI: "counter",
  HighFindingResourcesCountKPI: "counter",
  FindingsSummaryKPI: "counter",
  FindingInventoryKPI: "counter",
  ResourcesInventoryKPI: "counter",
};

export const widgetCategoriesNameOrder = [
  "Findings",
  "Resources",
  "Tickets",
  "SLA",
];

export const trendWidgetTypes = ["TrendChart", "FixedFindingsKPI"];
